import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import profileSetupApi from "../api/profileSetup";
import { toast } from "react-toastify";
import { IProfessionHobby, IProfessionSkill, IProfessionSubject, ITutorEducationDetails, ITutorExperienceDetails, ITutorPersonalDetails, ITutorProfessionDetails, ITutorRequest, ITutorRequestStatus } from "@wot/typings";

interface IInitalState {
  request: ITutorRequest | null;
  error: string;
  loading: boolean;
}

const initalState: IInitalState = {
  request: null,
  error: "",
  loading: false,
};

export const getTutorRequest = createAsyncThunk(
  "getTutorRequest",
  async (id: string, { fulfillWithValue, rejectWithValue }) => {
    const res = await profileSetupApi.getTutorRequest(id);
    if (res.status === "OK") {
      return fulfillWithValue(res.data);
    } else {
      rejectWithValue(res.message);
    }
  }
);
export const updatePersonal = createAsyncThunk(
  "updatePersonal",
  async (
    data: ITutorPersonalDetails,
    { fulfillWithValue, rejectWithValue, getState }
  ) => {
    // @ts-ignore
    const { tutor } = await getState().authSlice;
    const res = await profileSetupApi.profileSetup(data, tutor.id);
    if (res.status === "OK") {
      console.log(res.data)
      toast.success("Tutor Personal details Updated successfully!");
      return fulfillWithValue(res.data.personal);
    } else {
      toast.error("Something went wrong");
    }
  }
);

export const updateEducation = createAsyncThunk(
  "updateEducation",
  async (
    data: ITutorEducationDetails,
    { fulfillWithValue, rejectWithValue, getState }
  ) => {
    // @ts-ignore
    const { tutor } = getState().authSlice;
    const res = await profileSetupApi.updateEducation(data, tutor.id);
    if (res.status === "OK") {
      toast.success("Tutor Eucation Updated Successfully!");
      return fulfillWithValue(data);
    } else {
      toast.error("Something went wrong");
    }
  }
);
export const updateExperience = createAsyncThunk(
  "updateExperience",
  async (
    data: ITutorExperienceDetails,
    { fulfillWithValue, rejectWithValue, getState }
  ) => {
    // @ts-ignore
    const { tutor } = getState().authSlice;
    const res = await profileSetupApi.updateExperience(data, tutor.id);
    if (res.status === "OK") {
      toast.success("Tutor Experience Updated Successfully!");
      return fulfillWithValue(data);
    } else {
      toast.error("Something went wrong");
    }
  }
);
export const updateProfession = createAsyncThunk(
  "updateProfession",
  async (
    data: ITutorProfessionDetails<IProfessionSubject | IProfessionHobby | IProfessionSkill>,
    { fulfillWithValue, rejectWithValue, getState }
  ) => {
    // @ts-ignore
    const { tutor } = getState().authSlice;
    const res = await profileSetupApi.updateProfession(data, tutor.id);
    if (res.status === "OK") {
      toast.success("Tutor Profession Updated Successfully!");
      return fulfillWithValue(data);
    } else {
      toast.error("Something went wrong");
    }
  }
);
export const updateProfileStatus = createAsyncThunk(
  "updateProfileStatus",
  async (
    status: ITutorRequestStatus,
    { fulfillWithValue, rejectWithValue, getState }
  ) => {
    // @ts-ignore
    const { tutor } = getState().authSlice;
    const res = await profileSetupApi.updateProfileStatus(status, tutor.id);
    if (res.status === "OK") {
      toast.success("Tutor Profile sent to Admin for Verification!");
      return fulfillWithValue(status);
    } else {
      toast.error("Something went wrong");
    }
  }
);

export const acceptProfileAgreement = createAsyncThunk(
  "acceptProfileAgreement",
  async (_, { fulfillWithValue, rejectWithValue, getState }) => {
    // @ts-ignore
    const { tutor } = getState().authSlice;
    // @ts-ignore
    const { request } = getState().profileSetupSlice;
    const res = await profileSetupApi.acceptProfileAgreement(request._id);
    if (res.status === "OK") {
      return fulfillWithValue(res.data);
    }
  }
);

const profileSetupSlice = createSlice({
  name: "profileSetupSlice",
  initialState: initalState,
  reducers: {
    profileSetup: (state, { payload }) => {
      state.request = payload;
    },
  },
  extraReducers(builder) {
    builder.addCase(getTutorRequest.pending, (state, action) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(getTutorRequest.fulfilled, (state, action) => {
      // @ts-ignore
      state.request = action.payload;
      state.error = "";
      state.loading = false;
    });
    builder.addCase(getTutorRequest.rejected, (state, action) => {
      // @ts-ignore
      state.error = action.payload;
      state.loading = false;
    });

    builder.addCase(updatePersonal.fulfilled, (state, action) => {
      // @ts-ignore
      state.request = { ...state.request, personal: action.payload };
      state.error = "";
      state.loading = false;
    });
    builder.addCase(updateEducation.fulfilled, (state, action) => {
      // @ts-ignore
      state.request = { ...state.request, education: action.payload };

      state.error = "";
      state.loading = false;
    });
    builder.addCase(updateExperience.fulfilled, (state, action) => {
      // @ts-ignore
      state.request = { ...state.request, experience: action.payload };
      state.error = "";
      state.loading = false;
    });
    builder.addCase(updateProfession.fulfilled, (state, action) => {
      // @ts-ignore
      state.request = { ...state.request, profession: action.payload };
      state.error = "";
      state.loading = false;
    });
    builder.addCase(updateProfileStatus.fulfilled, (state, action) => {
      // @ts-ignore
      state.request.status = action.payload;
      state.error = "";
      state.loading = false;
    });

    builder.addCase(acceptProfileAgreement.fulfilled, (state, action) => {
      // @ts-ignore
      state.request = {
        ...state.request,
        status: "verified",
        // @ts-ignore
        agreement: {
          ...state.request?.agreement,
          status: "accpeted",
        },
      };
      state.error = "";
      state.loading = false;
    });
  },
});

export const { profileSetup } = profileSetupSlice.actions;

export default profileSetupSlice.reducer;
